module.exports = __webpack_public_path__ + "static/img/topImg.0b33db60.png";